import * as uuidv4 from "uuid/v4";

export default class GuidHelper {
    createGuid() {
        // Obsolete: Use id manager instead of guid
        return uuidv4.default();
    } 
}